import { useState } from 'react'
import { TICKET_TYPE_TREE, getTicketType } from '../../utils/ticketType'
import '../../styles/ticket-form.css'

/**
 * Selector del tipo de registro en dos niveles: familia (Soporte/Desarrollo) y
 * luego el tipo concreto. Arranca abierto en la familia del tipo actual.
 *
 * @component
 * @param {Object} props
 * @param {string} props.value - Tipo seleccionado.
 * @param {(value: string) => void} props.onChange
 * @param {boolean} [props.showExamples=false] - Muestra ejemplos del tipo elegido.
 * @returns {JSX.Element}
 */
const TicketTypePicker = ({ value, onChange, showExamples = false }) => {
  const [openGroup, setOpenGroup] = useState(() => getTicketType(value).group)
  const openGroupMeta = TICKET_TYPE_TREE.find((g) => g.value === openGroup)
  const selected = getTicketType(value)

  return (
    <div>
      <div className="at-group-grid">
        {TICKET_TYPE_TREE.map((group) => {
          const isOpen = openGroup === group.value
          const chosen = group.types.find((t) => t.value === value)
          return (
            <button
              key={group.value}
              type="button"
              className="at-group-card"
              onClick={() => setOpenGroup(group.value)}
              aria-expanded={isOpen}
              style={
                isOpen
                  ? { borderColor: group.color, background: `${group.color}12` }
                  : undefined
              }
            >
              <span
                className="at-group-icon"
                style={{ color: group.color, background: `${group.color}1f` }}
              >
                <i className={`fa-solid ${group.icon}`} />
              </span>
              <span className="at-group-texts">
                <span className="at-group-label">{group.label}</span>
                <span className="at-group-hint">{group.hint}</span>
              </span>
              {chosen && (
                <span
                  className="at-group-chip"
                  style={{
                    color: chosen.color,
                    background: `${chosen.color}1f`,
                  }}
                >
                  {chosen.label}
                </span>
              )}
            </button>
          )
        })}
      </div>

      {openGroupMeta && (
        <div className="at-type-grid">
          {openGroupMeta.types.map((item) => {
            const active = value === item.value
            return (
              <button
                key={item.value}
                type="button"
                className={`at-type-card ${active ? 'is-active' : ''}`}
                onClick={() => onChange(item.value)}
                title={item.hint}
                aria-pressed={active}
                style={
                  active
                    ? {
                        borderColor: item.color,
                        background: `${item.color}14`,
                        color: item.color,
                      }
                    : undefined
                }
              >
                <i className={`fa-solid ${item.icon}`} />
                <span>{item.label}</span>
              </button>
            )
          })}
        </div>
      )}

      {showExamples && (
        <div className="at-type-examples">
          <strong style={{ color: selected.color }}>{selected.label}:</strong>{' '}
          {selected.hint}. Por ejemplo:
          <ul className="mb-0 mt-1">
            {selected.examples.map((ex) => (
              <li key={ex}>{ex}</li>
            ))}
          </ul>
          <style>{`
            .at-type-examples {
              margin-top: 12px; padding: 10px 14px; border-radius: 10px;
              background: var(--gm-surface-2); font-size: 0.8rem; color: var(--gm-text-muted);
            }
          `}</style>
        </div>
      )}
    </div>
  )
}

export default TicketTypePicker
